import { CanDeactivateFn } from '@angular/router';
import type { WorkflowStartComponent } from './workflow-start.component';

export const workflowStartNavigationGuard: CanDeactivateFn<
  WorkflowStartComponent
> = (component) => component.confirmNavigation();
